module.exports = __webpack_public_path__ + "static/media/double-arrow-left.0f9c467a.svg";